import React, { useEffect } from 'react';
import { Grid2 as Grid, Paper, Typography } from '@mui/material';
import UnitDashboardSection from './UnitDashboardSection';
import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../../Redux/Reducer/rootReducer';
import { fetchAnnouncement, fetchBooking, fetchServiceRequest, fetchViolation, fetchVisitorParking } from '../../Redux/selectors';
import { useAuth } from '../../context/authContext';
import { userDashboardMaxLimits } from '../../Utils/Constants';

const UnitDashboard: React.FC = () => {

  const dispatch = useDispatch();
  const bookingData = useSelector(fetchBooking);
  const violationsData = useSelector(fetchViolation);
  const serviceRequestData = useSelector(fetchServiceRequest);
  const announcementData = useSelector(fetchAnnouncement);
  const visitorParkingData = useSelector(fetchVisitorParking);
  const { user } = useAuth();

  useEffect(() => {
    dispatch(Actions.fetchBooking.bookingActions.request({}));
    dispatch(Actions.fetchViolation.violationActions.request({}));
    dispatch(Actions.fetch.serviceRequestActions.request({}));
    dispatch(Actions.fetchAnnouncement.announcementActions.request({}));
    dispatch(Actions.fetchVisitorParking.visitorParkingActions.request({}));
    dispatch(Actions.fetchUnit.unitByUserActions.request({user_id: user.id}));
  }, []);

  return (
    <>
        <Paper elevation={5} sx={{borderRadius: 20, padding: 2, m: 4, justifyContent: 'center', display: 'flex', alignItems: 'center', verticalAlign: 'middle', background: '#f4f4f4'}}>
          <Typography variant="h4" gutterBottom>
            Unit Dashboard
          </Typography>
        </Paper>
        <Grid container spacing={1}>
        <Grid size={{xs: 12, md: 6}}>
            <UnitDashboardSection title="Visitor Parking" data={visitorParkingData?.slice(0, userDashboardMaxLimits.visitorParking)} hasMore={visitorParkingData.length > userDashboardMaxLimits.visitorParking} />
        </Grid>
        <Grid size={{xs: 12, md: 6}}>
            <UnitDashboardSection title="Announcements" data={announcementData?.slice(0, userDashboardMaxLimits.announcements)} hasMore={announcementData.length > userDashboardMaxLimits.announcements} />
        </Grid>
        <Grid size={{xs: 12}}>
            <UnitDashboardSection title="Service Requests" data={serviceRequestData?.slice(0, userDashboardMaxLimits.serviceRequests)} hasMore={serviceRequestData.length > userDashboardMaxLimits.serviceRequests} />
        </Grid>
        <Grid size={{xs: 12}}>
            <UnitDashboardSection title="Bookings" data={bookingData?.slice(0, userDashboardMaxLimits.bookings)} hasMore={bookingData.length > userDashboardMaxLimits.bookings} />
        </Grid>
        <Grid size={{xs: 12}}>
            <UnitDashboardSection title="Reported Violations" data={violationsData?.slice(0, userDashboardMaxLimits.violations)} hasMore={violationsData.length > userDashboardMaxLimits.violations} />
        </Grid>
        </Grid>
    </>
  );
};

export default UnitDashboard;
